import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';;
import { AbstractView } from '@core/interfaces';
import { SummaryPresenter } from './summary.presenter';
import { SummaryViewPresenter } from './interfaces';
import { SharedModule } from '@shared/shared.module';
import { Observable, of } from 'rxjs';
import { SkeletonModule } from 'primeng/skeleton';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-summary',
  standalone: true,
  imports: [
    SharedModule,
    SkeletonModule
  ],
  templateUrl: './summary.component.html',
  styleUrl: './summary.component.scss',
  providers: [ SummaryPresenter ]
})
export class SummaryComponent extends AbstractView<SummaryPresenter>
implements SummaryViewPresenter, OnInit {
  @Input() loading$: Observable<boolean> = of(false);
  @Input({required: true}) groupList$: Observable<MenuItem[]> = of([]);
  @Input({required: true}) subgroupList$: Observable<MenuItem[]> = of([]);
  @Input({required: true}) storeList$: Observable<MenuItem[]> = of([]);
  @Input({required: true}) title: string | null = null;
  @Input({required: true}) name: string | null = null;

  constructor(
    messageService: MessageService,
    router: Router,
    store: Store,
    presenter: SummaryPresenter
  ) {
    super(messageService, router, store, presenter);
  }
  
  ngOnInit(): void {
    this.presenter.setView(this);
  }

  getGroups(): string {
    return this.presenter.getGroups();
  }

  getSubgroups(): string {
    return this.presenter.getSubgroups();
  }

  getStores(): string {
    return this.presenter.getStores();
  }
}
